var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h4", [_vm._v(_vm._s(_vm.label))]),
    _vm._v(" "),
    _c("div", { staticClass: "category-filter" }, [
      _c(
        "div",
        { staticClass: "range-slider" },
        [
          _c(
            "no-ssr",
            [
              _c("vue-slider", {
                ref: "slider",
                attrs: {
                  formatter: "",
                  min: _vm.minValue,
                  max: _vm.maxValue,
                  piecewise: true,
                },
                model: {
                  value: _vm.sliderValue,
                  callback: function ($$v) {
                    _vm.sliderValue = $$v
                  },
                  expression: "sliderValue",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "range-slider-label" }, [
            _c("div", { staticClass: "minimum" }, [
              _vm._v("\n          " + _vm._s(_vm.minLabel) + "\n        "),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "maximum" }, [
              _vm._v("\n          " + _vm._s(_vm.maxLabel) + "\n        "),
            ]),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }